import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
   initialize() {
      const matcher = window.matchMedia("(prefers-color-scheme: dark)");
      const systemColorMode = matcher.matches ? "dark" : "light";
      const storedColorMode = localStorage.getItem("__reshaped-mode");

      document.documentElement.setAttribute("data-rs-color-mode", storedColorMode || systemColorMode);
      matcher.addEventListener("change", () => {
         document.documentElement.setAttribute("data-rs-color-mode", systemColorMode);
      });
   }
}
